// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_container__wdkN- {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  width: 100%;
}

.styles_courseForm__y937c {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.styles_formField__C9KWp {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
}

.styles_hits__BCJmq {
  display: none;
  font: var(--typography-body-s-regular);
  color: var(--color-text-secondary);
}
@media (min-width: 768px) {
  .styles_hits__BCJmq {
    display: block;
  }
}

.styles_fieldLabel__7Htvm {
  font: var(--typography-body-m-medium);
  color: var(--color-black);
  text-align: left;
  display: flex;
  align-items: center;
  gap: 4px;
}
.styles_fieldLabel--optional__QSKEI {
  font: var(--typography-body-s-regular);
  color: var(--color-text-secondary);
}

.styles_fieldError__JK4Xy {
  font: var(--typography-body-s-medium);
  color: var(--color-error);
  margin-top: 4px;
}

.styles_daysSelector__yihnM {
  display: flex;
  gap: 4px;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  padding: 4px;
  background-color: var(--color-bg-light-blue);
  border-radius: 10px;
  transition: border-color 0.2s ease;
  border: 1px solid var(--strokes-blue);
}
@media (min-width: 768px) {
  .styles_daysSelector__yihnM {
    gap: 8px;
    flex-wrap: wrap;
    flex-direction: row;
    align-items: center;
  }
}
.styles_daysSelector--error__-D8Bh {
  border-color: var(--color-error);
}

.styles_bigLabel__P8QZ0 {
  display: block;
}
@media (min-width: 768px) {
  .styles_bigLabel__P8QZ0 {
    display: none;
  }
}

.styles_smallLabel__Q9EMJ {
  display: none;
}
@media (min-width: 768px) {
  .styles_smallLabel__Q9EMJ {
    display: block;
  }
}

.styles_dayButton__oIBD0 {
  padding: 8px 12px;
  background-color: transparent;
  color: var(--color-text-secondary);
  font: var(--typography-body-s-medium);
  cursor: pointer;
  transition: all 0.2s ease;
  flex: 1 1;
  min-width: 0;
  width: 100%;
  text-align: start;
  outline: none;
  border-radius: 6px;
  border: 1px solid transparent;
}
.styles_dayButton__oIBD0:focus, .styles_dayButton__oIBD0:focus-visible {
  outline: none;
  box-shadow: none;
}
@media (min-width: 768px) {
  .styles_dayButton__oIBD0 {
    font: var(--typography-body-m-medium);
    width: fit-content;
    text-align: center;
  }
}
.styles_dayButton__oIBD0:hover {
  background-color: rgba(255, 255, 255, 0.5);
  color: var(--color-black);
}
.styles_dayButton--selected__sp79v {
  background-color: var(--color-white);
  color: var(--color-black);
  border: 1px solid var(--strokes-blue);
}
.styles_dayButton--selected__sp79v:hover {
  background-color: var(--color-white);
  color: var(--color-black);
  border: 1px solid var(--strokes-blue);
}
.styles_dayButton--selected__sp79v:focus, .styles_dayButton--selected__sp79v:focus-visible {
  outline: none;
  box-shadow: none;
  border: 1px solid var(--strokes-blue);
}

.styles_formActions__sTd1x {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
}
@media (min-width: 768px) {
  .styles_formActions__sTd1x {
    gap: 16px;
    margin-top: 16px;
  }
}

.styles_proceedButton__nP9DN {
  width: 100%;
}

.styles_excludeButton__AnWfS {
  width: 100%;
}

.styles_checkboxContainer__Qop1s {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
  cursor: pointer;
  font-size: 16px;
  -webkit-user-select: none;
          user-select: none;
  color: #333;
  font-weight: 500;
  position: relative;
  padding: 0;
}

.styles_customCheckbox__C4\\+4c {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

.styles_checkmark__lIJc0 {
  position: relative;
  height: 20px;
  width: 20px;
  background-color: #eee;
  border-radius: 4px;
  transition: background-color 0.3s;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
  flex-shrink: 0;
}

.styles_checkmark__lIJc0:after {
  content: "";
  position: absolute;
  display: none;
  left: 6.5px;
  top: 3px;
  width: 4px;
  height: 8px;
  border: solid white;
  border-width: 0 3px 3px 0;
  transform: rotate(45deg);
}

.styles_customCheckbox__C4\\+4c:checked ~ .styles_checkmark__lIJc0 {
  background-color: #2196F3;
  box-shadow: 0 3px 7px rgba(33, 150, 243, 0.3);
}

.styles_customCheckbox__C4\\+4c:checked ~ .styles_checkmark__lIJc0:after {
  display: block;
}

@keyframes styles_checkAnim__8WD4G {
  0% {
    height: 0;
  }
  100% {
    height: 8px;
  }
}
.styles_customCheckbox__C4\\+4c:checked ~ .styles_checkmark__lIJc0:after {
  animation: styles_checkAnim__8WD4G 0.2s forwards;
}

.styles_daysSelector--disabled__rtBSr {
  opacity: 0.5;
  pointer-events: none;
}

.styles_dayButton--disabled__9hzhS {
  opacity: 0.5;
  cursor: not-allowed;
  background-color: #f5f5f5 !important;
  color: #999 !important;
}

.styles_asyncNote__aoukq {
  margin-top: 8px;
  font-size: 14px;
  color: #666;
  font-style: italic;
}`, "",{"version":3,"sources":["webpack://./src/screens/choose-sections/styles.module.scss","webpack://./src/styles/mixins.scss"],"names":[],"mappings":"AACA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;AAAF;;AAGA;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAAF;;AAGA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,WAAA;AAAF;;AAGA;EACE,aAAA;EACA,sCAAA;EACA,kCAAA;AAAF;ACnBE;EDgBF;IAMI,cAAA;EACF;AACF;;AAEA;EACE,qCAAA;EACA,yBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AACF;AACE;EACE,sCAAA;EACA,kCAAA;AACJ;;AAGA;EACE,qCAAA;EACA,yBAAA;EACA,eAAA;AAAF;;AAGA;EACE,aAAA;EACA,QAAA;EACA,sBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,4CAAA;EACA,mBAAA;EACA,kCAAA;EACA,qCAAA;AAAF;ACxDE;ED8CF;IAaI,QAAA;IACA,eAAA;IACA,mBAAA;IACA,mBAAA;EACF;AACF;AACE;EACE,gCAAA;AACJ;;AAGA;EACE,cAAA;AAAF;ACvEE;EDsEF;IAII,aAAA;EACF;AACF;;AAEA;EACE,aAAA;AACF;AChFE;ED8EF;IAII,cAAA;EAEF;AACF;;AACA;EACE,iBAAA;EACA,6BAAA;EACA,kCAAA;EACA,qCAAA;EACA,eAAA;EACA,yBAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,aAAA;EACA,kBAAA;EACA,6BAAA;AAEF;AAAE;EAEE,aAAA;EACA,gBAAA;AACJ;ACzGE;EDsFF;IAsBI,qCAAA;IACA,kBAAA;IACA,kBAAA;EACF;AACF;AACE;EACE,0CAAA;EACA,yBAAA;AACJ;AAEE;EACE,oCAAA;EACA,yBAAA;EACA,qCAAA;AAAJ;AAEI;EACE,oCAAA;EACA,yBAAA;EACA,qCAAA;AAAN;AAGI;EAEE,aAAA;EACA,gBAAA;EACA,qCAAA;AAFN;;AAOA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,WAAA;AAJF;AC1IE;ED0IF;IAOI,SAAA;IACA,gBAAA;EAHF;AACF;;AAMA;EACE,WAAA;AAHF;;AAMA;EACE,WAAA;AAHF;;AAQA;EACE,oBAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;AALF;;AAQA;EACE,kBAAA;EACA,UAAA;EACA,eAAA;EACA,SAAA;EACA,QAAA;AALF;;AAQA;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,sBAAA;EACA,kBAAA;EACA,iCAAA;EACA,wCAAA;EACA,cAAA;AALF;;AAQA;EACE,WAAA;EACA,kBAAA;EACA,aAAA;EACA,WAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,mBAAA;EACA,yBAAA;EACA,wBAAA;AALF;;AAQA;EACE,yBAAA;EACA,6CAAA;AALF;;AAQA;EACE,cAAA;AALF;;AAQA;EACE;IACE,SAAA;EALF;EAOA;IACE,WAAA;EALF;AACF;AAQA;EACE,gDAAA;AANF;;AAUA;EACE,YAAA;EACA,oBAAA;AAPF;;AAUA;EACE,YAAA;EACA,mBAAA;EACA,oCAAA;EACA,sBAAA;AAPF;;AAWA;EACE,eAAA;EACA,eAAA;EACA,WAAA;EACA,kBAAA;AARF","sourcesContent":["@import \"mixins\";\n.container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 24px;\n  width: 100%;\n}\n\n.courseForm {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.formField {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  width: 100%;\n}\n\n.hits {\n  display: none;\n  font: var(--typography-body-s-regular);\n  color: var(--color-text-secondary);\n\n  @include md {\n    display: block;\n  }\n}\n\n.fieldLabel {\n  font: var(--typography-body-m-medium);\n  color: var(--color-black);\n  text-align: left;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n\n  &--optional {\n    font: var(--typography-body-s-regular);\n    color: var(--color-text-secondary);\n  }\n}\n\n.fieldError {\n  font: var(--typography-body-s-medium);\n  color: var(--color-error);\n  margin-top: 4px;\n}\n\n.daysSelector {\n  display: flex;\n  gap: 4px;\n  flex-direction: column;\n  align-items: flex-start;\n  width: 100%;\n  padding: 4px;\n  background-color: var(--color-bg-light-blue);\n  border-radius: 10px;\n  transition: border-color 0.2s ease;\n  border: 1px solid var(--strokes-blue);\n\n  @include md {\n    gap: 8px;\n    flex-wrap: wrap;\n    flex-direction: row;\n    align-items: center;\n  }\n\n  &--error {\n    border-color: var(--color-error);\n  }\n}\n\n.bigLabel {\n  display: block;\n\n  @include md {\n    display: none;\n  }\n}\n\n.smallLabel {\n  display: none;\n\n  @include md {\n    display: block;\n  }\n}\n\n.dayButton {\n  padding: 8px 12px;\n  background-color: transparent;\n  color: var(--color-text-secondary);\n  font: var(--typography-body-s-medium);\n  cursor: pointer;\n  transition: all 0.2s ease;\n  flex: 1;\n  min-width: 0;\n  width: 100%;\n  text-align: start;\n  outline: none;\n  border-radius: 6px;\n  border: 1px solid transparent;\n\n  &:focus,\n  &:focus-visible {\n    outline: none;\n    box-shadow: none;\n  }\n\n  @include md {\n    font: var(--typography-body-m-medium);\n    width: fit-content;\n    text-align: center;\n  }\n\n  &:hover {\n    background-color: rgba(255, 255, 255, 0.5);\n    color: var(--color-black);\n  }\n\n  &--selected {\n    background-color: var(--color-white);\n    color: var(--color-black);\n    border: 1px solid var(--strokes-blue);\n\n    &:hover {\n      background-color: var(--color-white);\n      color: var(--color-black);\n      border: 1px solid var(--strokes-blue);\n    }\n\n    &:focus,\n    &:focus-visible {\n      outline: none;\n      box-shadow: none;\n      border: 1px solid var(--strokes-blue);\n    }\n  }\n}\n\n.formActions {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  width: 100%;\n\n  @include md {\n    gap: 16px;\n    margin-top: 16px;\n  }\n}\n\n.proceedButton {\n  width: 100%;\n}\n\n.excludeButton {\n  width: 100%;\n}\n\n\n// Checkbox styles \n.checkboxContainer {\n  display: inline-flex;\n  align-items: center;\n  gap: 12px; \n  margin-bottom: 12px;\n  cursor: pointer;\n  font-size: 16px;\n  user-select: none;\n  color: #333;\n  font-weight: 500;\n  position: relative;\n  padding: 0; \n}\n\n.customCheckbox {\n  position: absolute;\n  opacity: 0;\n  cursor: pointer;\n  height: 0;\n  width: 0;\n}\n\n.checkmark {\n  position: relative; \n  height: 20px;\n  width: 20px;\n  background-color: #eee;\n  border-radius: 4px;\n  transition: background-color 0.3s;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);\n  flex-shrink: 0; \n}\n\n.checkmark:after {\n  content: \"\";\n  position: absolute;\n  display: none;\n  left: 6.5px;\n  top: 3px;\n  width: 4px;\n  height: 8px;\n  border: solid white;\n  border-width: 0 3px 3px 0;\n  transform: rotate(45deg);\n}\n\n.customCheckbox:checked ~ .checkmark {\n  background-color: #2196F3;\n  box-shadow: 0 3px 7px rgba(33, 150, 243, 0.3);\n}\n\n.customCheckbox:checked ~ .checkmark:after {\n  display: block;\n}\n\n@keyframes checkAnim {\n  0% {\n    height: 0;\n  }\n  100% {\n    height: 8px;\n  }\n}\n\n.customCheckbox:checked ~ .checkmark:after {\n  animation: checkAnim 0.2s forwards;\n}\n\n// Disabled day selector styles\n.daysSelector--disabled {\n  opacity: 0.5;\n  pointer-events: none;\n}\n\n.dayButton--disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  background-color: #f5f5f5 !important;\n  color: #999 !important;\n}\n\n// Async note styling\n.asyncNote {\n  margin-top: 8px;\n  font-size: 14px;\n  color: #666;\n  font-style: italic;\n}","@mixin sm {\n  @media (min-width: 640px) {\n    @content;\n  }\n}\n\n@mixin md {\n  @media (min-width: 768px) {\n    @content;\n  }\n}\n\n@mixin lg {\n  @media (min-width: 1024px) {\n    @content;\n  }\n}\n\n@mixin xl {\n  @media (min-width: 1280px) {\n    @content;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles_container__wdkN-`,
	"courseForm": `styles_courseForm__y937c`,
	"formField": `styles_formField__C9KWp`,
	"hits": `styles_hits__BCJmq`,
	"fieldLabel": `styles_fieldLabel__7Htvm`,
	"fieldLabel--optional": `styles_fieldLabel--optional__QSKEI`,
	"fieldError": `styles_fieldError__JK4Xy`,
	"daysSelector": `styles_daysSelector__yihnM`,
	"daysSelector--error": `styles_daysSelector--error__-D8Bh`,
	"bigLabel": `styles_bigLabel__P8QZ0`,
	"smallLabel": `styles_smallLabel__Q9EMJ`,
	"dayButton": `styles_dayButton__oIBD0`,
	"dayButton--selected": `styles_dayButton--selected__sp79v`,
	"formActions": `styles_formActions__sTd1x`,
	"proceedButton": `styles_proceedButton__nP9DN`,
	"excludeButton": `styles_excludeButton__AnWfS`,
	"checkboxContainer": `styles_checkboxContainer__Qop1s`,
	"customCheckbox": `styles_customCheckbox__C4+4c`,
	"checkmark": `styles_checkmark__lIJc0`,
	"checkAnim": `styles_checkAnim__8WD4G`,
	"daysSelector--disabled": `styles_daysSelector--disabled__rtBSr`,
	"dayButton--disabled": `styles_dayButton--disabled__9hzhS`,
	"asyncNote": `styles_asyncNote__aoukq`
};
export default ___CSS_LOADER_EXPORT___;
